import { FieldPath, FieldValues } from "react-hook-form";

import { ControlledInput, ControlledInputProperties } from "../ControlledInput/ControlledInput";
import { ProductStatus } from "./productStatusConfig";
import { ProductStatusSelect } from "./ProductStatusSelect";

type ControlledProductStatusSelectProps<T extends FieldValues, TName extends FieldPath<T>> = Omit<
  ControlledInputProperties<T, TName>,
  "render"
> & {
  placeholder?: string;
  isClearable?: boolean;
};

export const ControlledProductStatusSelect = <T extends FieldValues, TName extends FieldPath<T>>({
  placeholder,
  isClearable,
  ...controlledProperties
}: ControlledProductStatusSelectProps<T, TName>) => {
  return (
    <ControlledInput
      {...controlledProperties}
      render={({ onChange, value, ...field }) => (
        <ProductStatusSelect
          value={value as ProductStatus | null}
          onChange={onChange}
          placeholder={placeholder}
          isClearable={isClearable}
          {...field}
        />
      )}
    />
  );
};
